import { Component } from '@theme/component';

/**
 * A custom element that displays a product card.
 *
 * @typedef {object} Refs
 * @property {HTMLAnchorElement} productCardLink - The product card link element.
 * @property {import('slideshow').Slideshow} [slideshow] - The slideshow component.
 * @property {HTMLElement} [cardGallery] - The card gallery component.
 *
 * @typedef {Object} CountrySizeGuide
 * @property {string} country
 * @property {string} title
 * @property {Array<any>} unit
 * 
 * @extends {Component<Refs>}
 */

export class Sizechart extends Component {
  constructor() {
    super();
    /** @type {CountrySizeGuide[]} */
    const conv = /** @type {any} */ (window)['conversion_countries'];
    if (conv) {
      this.data = conv;
    }
    this.allUnitsCanChange = this.querySelectorAll('[data-unit-change]');
    this.countrySelect = this.querySelector('#tableId');
  }

  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('[data-change-unit]').forEach((el) => el.addEventListener('click', this.#handleChangeUnit));
    if(this.countrySelect) this.countrySelect.addEventListener('change', this.#handleChangeCountry);

  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Change unit size
   * @param {Event} event
   */
  #handleChangeUnit = (event) => {
    if(event.target) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const isCm = target.hasAttribute('data-unit-cm');
      let unit = isCm ? 'cm' : 'inch';

      this.querySelectorAll('[data-change-unit]').forEach((el) => {
        el.classList.toggle('active', el === target);
      });

      this.allUnitsCanChange.forEach((el) => {
        const size = parseFloat(el.textContent);
        if (unit === 'cm') {
          el.textContent = `${(size * 2.54).toFixed(1).replace(".0", "")}`;
        } else {
          el.textContent = (Math.ceil((size / 2.54) * 100) / 100).toString();
        }
      });
    }
  };

    /**
   * Change unit size
   * @param {Event} event
   */
  #handleChangeCountry = (event) => {
    if(event.target) {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement) || !this.data) return;
      const selectedItem = this.data.find(item => item.country.toUpperCase() === target.value.toUpperCase())
      const table = this.querySelector('#conversion-table');
      if(!table) return;
      const table_body_html = selectedItem?.unit.map(item => `<td>${item.size}</td>`).join('');
      const table_html = `
        <tbody>
          <tr>
            <th>${selectedItem?.title}</th>
            ${table_body_html}
          </tr>
        </tbody>`
      table.innerHTML = table_html;
    }
  };
}

if (!customElements.get('sizechart-component')) {
  customElements.define('sizechart-component', Sizechart);
}